import React from 'react';
import { useParams } from 'react-router-dom';
import { H1, Text } from '../components/ui/Typography';
import { Card } from '../components/ui/Card';
import SafeIcon from '../common/SafeIcon';
import { translations } from '../translations';

const KnowledgeBase = () => {
  const { lang = 'nl' } = useParams();
  
  // Dynamic translation binding
  const t = translations[lang]?.knowledge || translations.nl.knowledge;

  return (
    <div className="max-w-7xl mx-auto px-6 py-20">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <H1 className="mb-6">{t.title}</H1>
        <Text>{t.subtitle}</Text>
        
        <div className="mt-8 relative max-w-md mx-auto">
          <SafeIcon name="Search" className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-400" />
          <input 
            type="text" 
            placeholder={t.search} 
            className="w-full pl-12 pr-4 py-3 rounded-full border border-zinc-200 bg-white focus:outline-none focus:ring-2 focus:ring-zinc-900 focus:border-transparent premium-shadow" 
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {t.articles.map((article, i) => (
          <Card key={i} className="p-0 flex flex-col cursor-pointer group">
            <div className="h-48 bg-zinc-100 p-6 flex flex-col justify-between items-start">
              <span className="text-xs font-semibold bg-white px-3 py-1 rounded-full text-zinc-900 uppercase tracking-wider">
                {article.cat}
              </span>
              <SafeIcon name="BookOpen" className="text-zinc-300 text-4xl group-hover:scale-110 transition-transform" />
            </div>
            <div className="p-6 flex-grow flex flex-col justify-between bg-white">
              <h3 className="text-lg font-semibold text-zinc-900 mb-4 group-hover:text-zinc-600 transition-colors">
                {article.title}
              </h3>
              <div className="flex items-center text-xs text-zinc-500 gap-2">
                <SafeIcon name="Clock" /> {article.time} {t.readTime}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default KnowledgeBase;